import {remCalc} from '../../_utils'

/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

// Popovers styles TO BE DONE once we'll have list menu designs

export default {
    baseStyle: {
        container: {
            width: 'full',
            alignItems: 'center',
            // gap: remCalc(20),
        },
        popoverContent: {
            marginLeft: 'auto',
            marginRight: 'auto',
            border: 0,
            minWidth: '100%',
            position: 'absolute',
        },
        popoverBody: {
            boxShadow: 'xl',
            paddingTop: 3,
            paddingRight: 4,
            paddingBottom: 4,
            paddingLeft: 4,
            zIndex: 1,
        },
        popoverContainer: {
            paddingTop: 0,
            paddingBottom: 8,
            maxWidth: 'container.xxxl',
        },
        listMenuTriggerContainer: {
            position: 'relative',
            textStyle: 'body-large',
            color: 'background.accent.hover',
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(8),
            pr: remCalc(20),
            _after: {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                height: remCalc(42),
                background: 'transparent',
            },
        },
        listMenuTriggerGroup: {
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(8),
        },
        chevronIcon: {
            color: 'background.accent.hover',
        },
        listMenuSimpleTriggerLink: {
            cursor: 'pointer',
            zIndex: '2',
            fontWeight: 'bold',
            _hover: {
                textDecoration: 'none',
            },
        },
        listMenuTriggerLink: {
            cursor: 'pointer',
            pos: 'absolute',
            top: '0',
            left: '0',
            zIndex: '2',
            _hover: {
                textDecoration: 'none',
                fontWeight: 'bold',
            },
        },
        listMenuTriggerLinkActive: {
            fontWeight: 'bold',
        },
        listMenuContent: {
            px: remCalc(16),
            w: '100%',
            bg: 'background.base.default',
        },
        popoverOverlay: {
            pos: 'fixed',
            backgroundColor: 'background.overlay-modal',
            height: '100vh',
            zIndex: '-2',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
        },
        categoryContainer: {
            w: 'full',
            gap: remCalc(24),
            justifyContent: 'space-between',
        },
        subCategoryContainer: {
            w: 'full',
            justifyContent: 'space-between',
        },
        contentContainer: {
            maxW: 'container.xxl',
            m: 'auto',
            direction: 'column',
            gap: remCalc(24),
            py: remCalc(56),
        },
        footerContainer: {gap: remCalc(24)},
        exploreAllButton: {
            display: 'flex',
            alignItems: 'center',
            columnGap: remCalc(10),
            textStyle: 'body-large',
            color: 'text.primary',
            fontWeight: 'bold',
            _hover: {
                textDecoration: 'none',
            },
        },
        filterHeaderContainer: {
            display: 'flex',
            alignItems: 'center',
            top: `-${remCalc(36)}`,
            gap: remCalc(5),
            mb: remCalc(12),
        },
        filterHeaderContainerBreakpoint: {
            '@media (min-width: 1200px)': {
                position: 'absolute',
            },
        },
        filterHeaderText: {textStyle: 'body-small', color: 'text.primary'},
        filterheaderTag: {
            alignItems: 'center',
            textStyle: 'body-xxsmall',
            rounded: 'full',
            gap: remCalc(4),
            fontWeight: '500',
            p: `${remCalc(2)} ${remCalc(8)} ${remCalc(2)} ${remCalc(5)}`,
        },
        subCategoryHeaderContainer: {
            display: 'flex',
            gap: {lg: remCalc(16)},
            justifyContent: {base: 'space-between', lg: 'flex-start'},
            mb: {base: remCalc(16), md: remCalc(12), lg: remCalc(24)},
        },
        subCategoryHeaderText: {
            textStyle: {base: 'body-medium', md: 'body-small', lg: 'body-large'},
            color: 'text.primary',
            fontWeight: 'bold',
        },
        subCategoryHeaderLink: {
            textStyle: 'body-medium',
            color: 'button.text.text-default',
            fontWeight: 'bold',
            textDecoration: 'underline',
        },
        cardGroupContainer: {
            spacing: {base: remCalc(8), sm: remCalc(16), md: remCalc(24)},
        },
        tertiaryLink: {
            textStyle: 'body-large',
            color: 'text.primary',
            fontWeight: 'bold',
            _hover: {
                textDecoration: 'none',
            },
        },
    },
    parts: [
        'container',
        'stackContainer',
        'popoverContent',
        'popoverContainer',
        'listMenuTriggerContainer',
        'listMenuTriggerLink',
        'listMenuTriggerLinkActive',
        'listMenuTriggerIcon',
    ],
}
